module.exports = __webpack_public_path__ + "static/media/a37.21b3eb3a.jpg";